import { merge } from './date/merge-date';
import * as React from 'react';
import { InputControlContext } from '../common/input-control-context/input-control-context';
import { DatePicker } from './date/date';
import { TimePicker } from './time/time';
import { DateTimeProps } from 'ui/date-time/date-time-props';

interface DateTimeState{
  date?: Date;
  time?: Date;
}

/**
 * @private get browser culture when component does not receive locale as prop
 */
export const getLocaleFromBrowser = (): string => {
  const nav: any = navigator;
  return (nav.languages && nav.languages.length ? nav.languages[0] : nav.language)
    || nav.userLanguage || nav.browserLanguage || 'no';
};

export class DateTime extends React.PureComponent<DateTimeProps, DateTimeState> {

  /**
   * Creates a DateTime component.
   *
   * @constructor.
   */
  constructor(props: DateTimeProps) {
    super(props);
    this.state = { time: props.value, date: props.value};
  }

  public UNSAFE_componentWillReceiveProps(props: DateTimeProps) {
    if(props.value !== this.state.date ){
      this.setState({ time: props.value, date: props.value });
    }
  }

  /**
   * Nested components may provide partial parts of the final Date we provide as
   * final callback argument. Merged here.
   *
   * @private
   * @param timeOrDate
   */
  private fireOnChangeCallback = () => {
    const { date, time } = this.state;
    const value = merge(this.props.createDate(), date, time);
    this.props.onChange(value);
  };

  private onChangeTime = (date: Date) => {
    this.setState((prevState) => ({
      // only allow value for time if there is a date part as well
      time: prevState.date ? date : null
    }), () => this.fireOnChangeCallback());
  };

  private onChangeDate = (date: Date) => {
    this.setState((prevState: any, currentProps: DateTimeProps) => ({
      date,
      // clear time if date was cleared. If date was set after it was empty, don't keep the stored time
      time: date && currentProps.value ? prevState.time : null
    }), () => this.fireOnChangeCallback());
  };

  public render() {
    const { useTime, locale = getLocaleFromBrowser(), readOnly, componentId, label, info, infoLong, validation } = this.props;

    const datePicker = <DatePicker  {
      ...{
        ...this.props,
        ...{
          useTime,
          locale,
          onChange: readOnly !== true && this.onChangeDate
        }
      }
    } />;

    const timePicker = <TimePicker {
      ...{
        ...this.props,
        ...{
          value: this.state.time,
          useTime,
          locale,
          onChange: readOnly !== true && this.onChangeTime
        }
      }
    } />;

    const dateComponent = !!useTime ?
      <div className="row">
        <div className="col-12 col-sm-8 col-lg-7 field-group-left-sm" key={1}>{datePicker}</div>
        <div className="col-12 col-sm-4 col-lg-5 field-group-right-sm" key={2}>{timePicker}</div>
      </div>
      :
      <div className="row">
        <div className="col-12" key={1}>{datePicker}</div>
      </div>;

    const readOnlyView = <div className="flex">
      <div className={!useTime ? 'flex-grow' : ''} key={1}>{datePicker}</div>
      {useTime ? <div className="flex-grow" key={2}>{timePicker}</div> : null}
    </div>;

    return (
      <InputControlContext
        componentId={componentId}
        label={label}
        info={info}
        infoLong={infoLong}
        validation={validation}
        readOnly={readOnly}
        className={`${this.props.className}`}
        showAIChatIcon={this.props.showAIChatIcon}
      >
        {readOnly ? readOnlyView : dateComponent}
      </InputControlContext>
    );
  }
}
